<!-- 环境信息组件 -->
<template>
    <div class="pageContentSpecial environmentBox">
        <div class="environmentContent commonPadding">
            <transition>
                <template v-if="!selectSensorType">
                    <div class="environmentTableBox">
                        <div class="environmentTop">
                            <div class="environmentTopTitleBox">
                                <div class="environmentTopTitle">{{ $t("page.environmentInfo.environmentMetrics") }}
                                </div>
                                <div class="environmentTopTime">{{ $t("page.environmentInfo.reportDate") }}：{{
                                    nowDate || "-" }}</div>
                            </div>
                            <div class="environmentTableRow">
                                <div></div>
                                <div class="environmentTableHeaderItem">{{ $t("page.environmentInfo.minValue") }}</div>
                                <div class="environmentTableHeaderItem">{{ $t("page.environmentInfo.averageValue") }}
                                </div>
                                <div class="environmentTableHeaderItem">{{ $t("page.environmentInfo.maxValue") }}</div>
                            </div>
                        </div>
                        <div class="environmentTableCon">
                            <template v-if="sensorList.length > 0">
                                <div class="environmentTableRow" v-for="item in sensorList" :key="item.sensorId">
                                    <div class="environmentTableRowItem">
                                        <div class="environmentTableRowItemText">{{ item.sensorName || "-" }}</div>
                                        <div class="environmentTableRowItemUnit" v-if="item.unit">({{ item.unit }})
                                        </div>
                                        <div class="environmentTableRowLine"></div>
                                    </div>
                                    <div class="environmentTableRowColumnItem">
                                        {{ item['minNumber'] || "-" }}
                                        <div class="environmentTableRowLine"></div>
                                    </div>
                                    <div class="environmentTableRowColumnItem">
                                        {{ item['average'] || "-" }}
                                        <div class="environmentTableRowLine"></div>
                                    </div>
                                    <div class="environmentTableRowColumnItem">
                                        {{ item['maxNumber'] || "-" }}
                                        <div class="environmentTableRowLine"></div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="environmentTableEmpty">
                                    <CommonEmpty :description="$t('empty.noEnvironmentMetrics')" />
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="environmentChartBox">
                        <div class="environmentChartTitle">{{ calcChartTitle }}</div>
                        <div class="environmentChart" id="environmentChart"></div>
                        <div class="environmentChartLegendBox">
                            <div class="environmentChartLegendItem">
                                <div class="environmentChartLegendItemLine first"></div>
                                <div class="environmentChartLegendItemText">{{ selectSensor.sensorName || "-" }}</div>
                            </div>
                            <div class="environmentChartLegendItem">
                                <div class="environmentChartLegendItemLine second"></div>
                                <div class="environmentChartLegendItemText">{{
                                    $t("page.environmentInfo.highestWarningValue") }}</div>
                            </div>
                            <div class="environmentChartLegendItem">
                                <div class="environmentChartLegendItemLine third"></div>
                                <div class="environmentChartLegendItemText">{{
                                    $t("page.environmentInfo.lowestWarningValue") }}</div>
                            </div>
                        </div>
                        <div class="whiteCard environmentChartCard">
                            <div class="environmentChartCardColumn">
                                <div class="environmentChartCardColumnValue">{{ selectSensor.minNumber || "-" }}</div>
                                <div class="environmentChartCardColumnLabel">
                                    {{ $t("page.environmentInfo.minValue") }}
                                    <div class="environmentChartCardColumnUnit" v-if="selectSensor.unit">({{
                                        selectSensor.unit }})</div>
                                </div>
                            </div>
                            <div class="environmentChartCardColumn">
                                <div class="environmentChartCardColumnValue">{{ selectSensor.average || "-" }}</div>
                                <div class="environmentChartCardColumnLabel">
                                    {{ $t("page.environmentInfo.averageValue") }}
                                    <div class="environmentChartCardColumnUnit" v-if="selectSensor.unit">({{
                                        selectSensor.unit }})</div>
                                </div>
                            </div>
                            <div class="environmentChartCardColumn">
                                <div class="environmentChartCardColumnValue environmentChartCardColumnMax">{{
                                    selectSensor.maxNumber || "-" }}</div>
                                <div class="environmentChartCardColumnLabel">
                                    {{ $t("page.environmentInfo.maxValue") }}
                                    <div class="environmentChartCardColumnUnit" v-if="selectSensor.unit">({{
                                        selectSensor.unit }})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </transition>
        </div>
        <div class="environmentBottom">
            <div class="environmentBottomItemBox">
                <div class="environmentBottomItem"
                    :class="{ environmentBottomItemActive: selectSensorType == item.sensorId }"
                    v-for="item in sensorList" :key="item.sensorId" @click="changeSelectType(item)">
                    <i class="c-icon environmentBottomItemIcon" :class="calcSensorIcon(item.mac)"></i>
                    <div class="environmentBottomItemText ellipsis">{{ item.sensorName }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SENSOR_ICON, CODE_SUCCESS } from "../../utils/constant";
import { chartOptions } from "./modules/chartOptions.js";
import * as echarts from 'echarts';
export default {
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            sensorInfo: {}, // 传感器信息对象，包含日期等数据
            sensorList: [], // 传感器列表数据
            selectSensorType: null, // 选择的传感器类型
            chartData: {}, // 图表数据
            myChart: null, // echarts实例
            chartDataOptions: {}, // 图表配置项
            nowDate: "", // 当前日期
        };
    },
    computed: {
        calcChartTitle() {
            const findItem = this.sensorList.find(item => item.sensorId == this.selectSensorType);
            if (findItem) {
                return `${findItem.sensorName}${this.$t("page.environmentInfo.trendChart")}`
            } else {
                return "-"
            }
        },
        selectSensor() {
            const findItem = this.sensorList.find(item => item.sensorId == this.selectSensorType);
            if (findItem) {
                return findItem;
            } else {
                return {}
            }
        },
    },
    methods: {
        refresh() {
            this.nowDate = this.formatDate(new Date());
            this.getSensorType();
        },
        formatDate(date) {
            return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                .toISOString()
                .slice(0, 19)
                .replace('T', ' ');
        },
        async getSensorType() {
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    plantId: this.info.plantId,
                }
                const res = await this.$api.fetchGetEquipmentSecondByIds(params);
                const dataParams = {
                    plantId: this.info.plantId,
                    pickId: this.info.pickId,
                }
                const dataRes = await this.$api.fetchGetDataByIds(dataParams);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else if (dataRes.code != CODE_SUCCESS) {
                    this.$toast.fail(dataRes.msg);
                } else {
                    const list = res.data || [];
                    const data = dataRes.data || [];
                    this.sensorList = list.map((item, index) => {
                        const findItem = data.find(dataItem => dataItem.id == item.id) || {};
                        return {
                            sensorId: item.id,
                            sensorName: item.nickName || "-",
                            mac: item.mac,
                            unit: findItem?.unit || "-",
                            maxNumber: findItem?.max || 0,
                            minNumber: findItem?.min || 0,
                            average: findItem?.average || 0,
                        }
                    });
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        async getChartData() {
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            this.chartDataOptions = {};
            try {
                const res = await this.$api.fetchZdDataByIdEquipmentSecondById({
                    zdEquipmentSecondId: this.selectSensorType,
                    plantId: this.info.plantId,
                    pickId: this.info.pickId,
                });
                this.$toast.clear();
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.sensorInfo = res.data || [];
                    let hight = 0;
                    let low = 0;
                    // 从yData数组中获取最大值和最小值
                    const yData = this.sensorInfo.map(item => item.value) || [];
                    if (yData.length > 0) {
                        hight = Math.max(...yData);
                        low = Math.min(...yData);
                    }
                    this.chartDataOptions = {
                        ...chartOptions,
                    }
                    this.chartDataOptions.xAxis.data = this.sensorInfo.map(item => item.time) || []; // 设置x轴数据
                    this.chartDataOptions.series[0].data = yData || []; // 设置y轴数据
                    this.chartDataOptions.series[0].markLine.data[0].yAxis = hight || 0; // 设置x轴数据
                    this.chartDataOptions.series[0].markLine.data[1].yAxis = low || 0; // 设置x轴数据
                    if (this.myChart) {
                        this.myChart.setOption(this.chartDataOptions); // 设置配置项。
                    } else {
                        this.initChart(); // 初始化echarts实例。
                    }
                }
            } catch (error) {
                this.$toast.clear();
                console.error("错误", error);
            }
        },
        /**
        * 根据列名计算并返回对应的传感器图标类名
        *
        * @param {string} [columnName=""] - 可选的列名，格式为"xxx-type_xxx"
        * @returns {string} 对应的传感器图标类名，如果无法匹配则返回空字符串
        */
        calcSensorIcon(columnName = "") {
            let iconClass = "";
            if (columnName) {
                const handleColumnName = columnName.split("-")[1];
                const iconType = handleColumnName.split("_")[0];
                if (iconType) {
                    iconClass = SENSOR_ICON[iconType];
                }
            }
            return iconClass;
        },
        changeSelectType(item) {
            if (this.selectSensorType != item.sensorId) {
                this.selectSensorType = item.sensorId;
                this.initChart(); // 初始化echarts实例。
                this.getChartData();
            } else {
                this.selectSensorType = null;
                if (this.myChart != null && this.myChart.dispose) {
                    this.myChart.dispose(); // 销毁echarts实例，释放内存资源等。
                }
            }
        },
        initChart() {
            this.$nextTick(() => {
                // 基于准备好的dom，初始化echarts实例
                this.myChart = echarts.init(document.getElementById('environmentChart'));
                this.myChart.setOption(this.chartDataOptions); // 设置配置项。
            })
        },
    },
};
</script>

<style scoped>
.environmentBox {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}

.environmentContent {
    width: 100%;
    flex: 1;
    height: 0;
    overflow: hidden;
    overflow-y: auto;
}

.environmentTop {
    width: 100%;
    border-radius: 20px 20px 0px 0px;
    background: linear-gradient(90deg, rgba(32, 178, 227, 1) 0%, rgba(42, 130, 228, 1) 100%);
    min-height: 80px;
    padding: 10px 10px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.environmentTopTitleBox {
    width: fit-content;
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    padding: 0 10px;
    box-sizing: border-box;
}

.environmentTopTitle {
    font-size: 16px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
}

.environmentTopTime {
    font-size: 9px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}

/* 表格样式 */
.environmentTableBox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.environmentTableRow {
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(1, 1fr);
    column-gap: 10px;
}

.environmentTableHeaderItem {
    width: 100%;
    height: 27px;
    opacity: 1;
    border-radius: 8px 8px 0px 0px;
    background: rgba(210, 232, 252, 1);
    font-size: 14px;
    font-weight: 700;
    color: var(--h5-color-blue);
    display: flex;
    justify-content: center;
    align-items: center;
}

.environmentTableCon {
    width: 100%;
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 0px 0px 20px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 2px rgba(16, 16, 16, 0.05);
    padding: 0 10px;
    box-sizing: border-box;
}

.environmentTableRowItem {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 700;
    color: var(--h5-color-gray);
    position: relative;
}

.environmentTableRowLine {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    width: 58px;
    background: linear-gradient(90deg, rgba(42, 130, 228, 0) 0%, rgba(42, 130, 228, 1) 47.44%, rgba(42, 130, 228, 0) 100%);
}


.environmentTableRow:last-child .environmentTableRowItem .environmentTableRowLine {
    display: none;
}

.environmentTableRowItemUnit {
    font-size: 7px;
    font-weight: 400;
    transform: translateY(3px);
    color: var(--h5-color-gray);
}

.environmentTableRowColumnItem {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 400;
    color: var(--h5-color-gray);
    background: rgba(245, 249, 255, 1);
    box-shadow: 0px 2px 2px rgba(16, 92, 163, 0.42);
    position: relative;
}

.environmentTableRow:last-child .environmentTableRowColumnItem .environmentTableRowLine {
    position: absolute;
    bottom: -4px;
    left: 0;
    transform: none;
    height: 4px;
    width: 100%;
    background: var(--h5-color-blue);
}

.environmentTableEmpty {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 图表样式 */
.environmentChartBox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}

.environmentChartTitle {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    color: var(--h5-color-gray);
}

.environmentChart {
    width: 100%;
    flex: 1;
}

.environmentChartLegendBox {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 10px;
}

.environmentChartLegendItem {
    width: fit-content;
    display: flex;
    align-items: center;
    column-gap: 4px;
}

.environmentChartLegendItemLine {
    width: 28px;
    height: 7px;
    border-radius: 4px;
}

.first {
    background: var(--h5-color-blue);
}

.second {
    background: var(--h5-color-red);
}

.third {
    background: var(--h5-color-green);
}

.environmentChartLegendItemText {
    font-size: 14px;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
}

.environmentChartCard {
    height: 80px;
    padding: 10px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, 1fr);
}

.environmentChartCardColumn {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 5px;
    border-right: 0.5px solid var(--h5-color-gray);
}

.environmentChartCardColumn:last-child {
    border-right: none;
}

.environmentChartCardColumnValue {
    font-size: 25px;
    font-weight: 500;
    color: var(--h5-color-blue);
}

.environmentChartCardColumnLabel {
    font-size: 16px;
    font-weight: 400;
    color: var(--h5-color-gray);
    display: flex;
}

.environmentChartCardColumnUnit {
    font-size: 10px;
    font-weight: 400;
    color: var(--h5-color-gray);
    transform: translateY(7px);
}

.environmentChartCardColumnMax {
    color: var(--h5-color-red);
}

/* 底部样式 */
.environmentBottom {
    width: 100%;
    height: 100px;
    border-radius: 10px 10px 0px 0px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 2px rgba(16, 16, 16, 0.05);
    padding: 20px 20px 10px;
    box-sizing: border-box;
}

.environmentBottomItemBox {
    width: 100%;
    height: 100%;
    display: flex;
    column-gap: 12px;
    overflow: hidden;
    overflow-x: auto;
    padding-bottom: 10px;
    box-sizing: border-box;
}

.environmentBottomItem {
    padding: 7px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 0.5px solid var(--h5-color-lightGray);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 5px;
    flex-shrink: 1;
}

.environmentBottomItemIcon {
    width: 27px;
    height: 27px;
    filter: grayscale(90%);
}

.environmentBottomItemText {
    font-size: 10px;
    font-weight: 700;
    color: var(--h5-color-lightGray);
}

.environmentBottomItemActive {
    border-color: var(--h5-color-blue);
    background: rgba(42, 130, 228, 0.1);
}

.environmentBottomItemActive .environmentBottomItemIcon {
    filter: grayscale(0%);
}

.environmentBottomItemActive .environmentBottomItemText {
    color: var(--h5-color-blue);
}
</style>